import {Box3,Matrix4,Vector3} from 'three';
/** Keep the complete rotated footprint inside the two walls, magnetized to
 * the nearer wall. Distances are room meters, independent of camera zoom. */
export function snapBunkToWalls(anchor:Vector3,origin:Vector3,basis:Matrix4,footprint:Box3,turn:number){
 const inverse=basis.clone().invert(),local=anchor.clone().sub(origin).applyMatrix4(inverse);
 const rotated=footprint.clone().applyMatrix4(new Matrix4().makeRotationY(turn*Math.PI/180));
 const x=Math.max(-rotated.min.x,local.x),z=Math.max(-rotated.min.z,local.z);
 if(x+rotated.min.x<=z+rotated.min.z)local.set(-rotated.min.x,0,z);
 else local.set(x,0,-rotated.min.z);
 return local.applyMatrix4(basis).add(origin);
}
export function bunkFootprintsOverlap(a:Box3,b:Box3,gap=.0254){
 return a.min.x<b.max.x+gap&&a.max.x>b.min.x-gap&&a.min.z<b.max.z+gap&&a.max.z>b.min.z-gap;
}
